import t_10_2064_colorized from './KZ.T.10.2064.svg'
import t_10_2064 from './KZ.T.10.2064 black.svg'

export default [
  t_10_2064_colorized,
  t_10_2064
]
